import profilePic from './images/profile1.jpg'
import b1 from "./images/b1.jpg"

export const PData=[
    {
    BusinessName:"Business Name1",
    BusinessAddress:"794 Bathurst Street Toronto Ontario M5R 3G1",
    BPhone:"9212345566",
    rating:4,
    coverPhoto:b1,
    logo:profilePic,
},
    {
    BusinessName:"Business Name2",
    BusinessAddress:"794 Bathurst Street Toronto Ontario M5R 3G1",
    BPhone:"9212345566",
    rating:4.5,
    coverPhoto:b1,
    logo:profilePic,
},
    {
    BusinessName:"Business Name3",
    BusinessAddress:"794 Bathurst Street Toronto Ontario M5R 3G1",
    BPhone:"9212345566",
    rating:3.7,
    coverPhoto:b1,
    logo:profilePic,
},
    {
    BusinessName:"Business Name4",
    BusinessAddress:"794 Bathurst Street Toronto Ontario M5R 3G1",
    BPhone:"9212345566",
    rating:3.5,
    coverPhoto:b1,
    logo:profilePic,
},
    {
    BusinessName:"Business Name",
    BusinessAddress:"794 Bathurst Street Toronto Ontario M5R 3G1",
    BPhone:"9212345566",
    rating:4.9,
    coverPhoto:b1,
    logo:profilePic,
},
    {
    BusinessName:"Business Name",
    BusinessAddress:"794 Bathurst Street Toronto Ontario M5R 3G1",
    BPhone:"9212345566",
    rating:4.1,
    coverPhoto:b1,
    logo:profilePic,
},
    {
    BusinessName:"Business Name5",
    BusinessAddress:"794 Bathurst Street Toronto Ontario M5R 3G1",
    BPhone:"9212345566",
    rating:4.5,
    coverPhoto:b1,
    logo:profilePic,
},
    {
    BusinessName:"Business Name7",
    BusinessAddress:"794 Bathurst Street Toronto Ontario M5R 3G1",
    BPhone:"9212345566",
    rating:4.6,
    coverPhoto:b1,
    logo:profilePic,
},
    {
    BusinessName:"Business Name8",
    BusinessAddress:"794 Bathurst Street Toronto Ontario M5R 3G1",
    BPhone:"9212345566",
    rating:2.6,
    coverPhoto:b1,
    logo:profilePic,
},
]